var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasCouponOffers()
    ? _c(
        "div",
        { staticClass: "offers-container" },
        [
          _c("div", { staticClass: "offer-emoji" }, [_vm._v("\n\t\t🎊\n\t")]),
          _vm._v(" "),
          _c("div", { staticClass: "offer-message" }, [
            _vm._v(
              "\n\t\t" +
                _vm._s(_vm.customerName) +
                ", " +
                _vm._s(_vm.offerCouponMessage) +
                "\n\t"
            )
          ]),
          _vm._v(" "),
          _vm._l(_vm.getCouponOffers(), function(offer, index) {
            return _c(
              "div",
              { key: _vm.offerKey(offer, index), staticClass: "offer-wrapper" },
              [_c("offer-coupon-item", { attrs: { offer: offer } })],
              1
            )
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d38cf70c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d38cf70c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkout/OfferCoupons.vue
// module id = null
// module chunks = 